/** TextureRect registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTextureRect } from './parser';
const textureRectRegistration = {
    typeName: 'TextureRect',
    parser: parseTextureRect,
};
nodeRegistry.register(textureRectRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map